import { render, staticRenderFns } from "./PayoutsList.vue?vue&type=template&id=d0c87b26&scoped=true&"
import script from "./PayoutsList.vue?vue&type=script&lang=js&"
export * from "./PayoutsList.vue?vue&type=script&lang=js&"
import style0 from "./PayoutsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PayoutsList.vue?vue&type=style&index=1&id=d0c87b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c87b26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VPagination,VRow})
